import React, { useState, useEffect } from 'react';
import utils from "../services/utils";
import managebusiness from "../services/managebusiness";

const GeneralManage = (props) => {
    const [businessInfo, setBusinessInfo] = useState({
        name: '',
        description: '',
        phone: '',
        location: '',
        website: '',
        social_facebook: '',
        social_instagram: '',
        banner_image: '',
        menu_file: ''
    });
    const [loading, setLoading] = useState(false);
    const [saved, setSaved] = useState(false);

    useEffect(() => {
        if (props.isOwner) {
            loadBusinessInfo();
        }
    }, [props.isOwner]);

    // Pre-fill with existing business data from props
    useEffect(() => {
        if (props.existingBusinessData) {
            const existing = props.existingBusinessData;
            // Get name from existing data (handles both old and new formats)
            let existingName = '';
            if (existing.names && Array.isArray(existing.names) && existing.names[0]?.name) {
                existingName = existing.names[0].name;
            } else if (existing.name) {
                existingName = existing.name;
            }

            setBusinessInfo(prev => ({
                ...prev,
                name: existingName || prev.name,
                phone: existing.phone || prev.phone,
                location: existing.location || existing.address || prev.location,
                description: existing.description || prev.description,
                website: existing.website || prev.website,
            }));
        }
    }, [props.existingBusinessData]);

    const loadBusinessInfo = async () => {
        setLoading(true);
        const data = await managebusiness.getBusinessInfo();
        if (data) {
            setBusinessInfo(prev => ({ ...prev, ...data }));
        }
        setLoading(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setBusinessInfo(prev => ({ ...prev, [name]: value }));
        setSaved(false);
    };

    // Business-profile editing has no PHP act yet (managebusiness is a read-only stub).
    // Show a clear "coming soon" instead of erroring, until the backend supports it.
    const handleSave = async () => {
        alert('שמירת פרטי העסק תתווסף בקרוב (בהמתנה לצד השרת).');
    };

    const handleFileUpload = async () => {
        alert('העלאת קבצים תתווסף בקרוב (בהמתנה לצד השרת).');
    };

    return (
        <div className="general-manage-container">
            {/* Business Switcher - always visible */}
            <div className="welcome-section">
                <span>ברוכים הבאים, לעסק: </span>
                <select onChange={props.handleChangeBus}>{props.renderBusiness()}</select>
            </div>

            {/* Restaurant Info Form - owner only */}
            {props.isOwner && (
                <div className="restaurant-info-form">
                    <h3>פרטי העסק</h3>

                    <div className="form-section">
                        <label>שם המסעדה</label>
                        <input
                            type="text"
                            name="name"
                            value={businessInfo.name || ''}
                            onChange={handleChange}
                            placeholder="שם המסעדה"
                        />
                    </div>

                    <div className="form-section">
                        <label>תיאור קצר</label>
                        <textarea
                            name="description"
                            value={businessInfo.description || ''}
                            onChange={handleChange}
                            placeholder="תיאור קצר של המסעדה"
                            rows={3}
                        />
                    </div>

                    <div className="form-row">
                        <div className="form-section">
                            <label>טלפון</label>
                            <input
                                type="tel"
                                name="phone"
                                value={businessInfo.phone || ''}
                                onChange={handleChange}
                                placeholder="050-123-4567"
                                dir="ltr"
                            />
                        </div>
                        <div className="form-section">
                            <label>כתובת</label>
                            <input
                                type="text"
                                name="location"
                                value={businessInfo.location || ''}
                                onChange={handleChange}
                                placeholder="כתובת העסק"
                            />
                        </div>
                    </div>

                    <div className="form-section">
                        <label>אתר אינטרנט</label>
                        <input
                            type="url"
                            name="website"
                            value={businessInfo.website || ''}
                            onChange={handleChange}
                            placeholder="https://www.example.com"
                            dir="ltr"
                        />
                    </div>

                    <div className="form-row">
                        <div className="form-section">
                            <label>פייסבוק</label>
                            <input
                                type="url"
                                name="social_facebook"
                                value={businessInfo.social_facebook || ''}
                                onChange={handleChange}
                                placeholder="קישור לפייסבוק"
                                dir="ltr"
                            />
                        </div>
                        <div className="form-section">
                            <label>אינסטגרם</label>
                            <input
                                type="url"
                                name="social_instagram"
                                value={businessInfo.social_instagram || ''}
                                onChange={handleChange}
                                placeholder="קישור לאינסטגרם"
                                dir="ltr"
                            />
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-section">
                            <label>תמונת באנר</label>
                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleFileUpload(e, 'banner')}
                            />
                            {businessInfo.banner_image && (
                                <img
                                    src={businessInfo.banner_image}
                                    alt="באנר"
                                    style={{ maxWidth: '200px', marginTop: '10px', borderRadius: '8px' }}
                                />
                            )}
                        </div>
                        <div className="form-section">
                            <label>תפריט (PDF / תמונה)</label>
                            <input
                                type="file"
                                accept="image/*,.pdf"
                                onChange={(e) => handleFileUpload(e, 'menu')}
                            />
                            {businessInfo.menu_file && (
                                <a
                                    href={businessInfo.menu_file}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ display: 'block', marginTop: '10px', color: 'var(--primary)' }}
                                >
                                    צפייה בתפריט
                                </a>
                            )}
                        </div>
                    </div>

                    <button
                        className="save-btn"
                        onClick={handleSave}
                        disabled={loading}
                        style={{
                            background: saved ? 'var(--success)' : 'var(--brand)',
                            color: 'white',
                            padding: '12px 30px',
                            border: 'none',
                            borderRadius: 'var(--r-md)',
                            fontSize: '16px',
                            fontWeight: '700',
                            cursor: 'pointer',
                            marginTop: '20px'
                        }}
                    >
                        {loading ? 'שומר…' : saved ? 'נשמר!' : 'שמירת שינויים'}
                    </button>
                </div>
            )}
        </div>
    );
};

export default GeneralManage;